import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8 8v8h8","key":"svg-0"}]]

const IconChevronDownLeft = createReactComponent('outline', 'chevron-down-left', 'ChevronDownLeft', __iconNode);

export default IconChevronDownLeft;